import numeral from 'numeral';
import { numberConstants } from '@/utils/constants';

export default function numberFormat(value, format = numberConstants.FORMAT.DEFAULT) {
    return numeral(value).format(format);
}
